<template>
  <b-container fluid id="main_nav"
               class="flex-grow-1 h-100"
               v-bind:class="$mq"
               v-bind:style="{ width: width }"
               v-click-outside="outside_click">
    <b-row no-gutters v-if="$mq == 'lg'">
      <b-col>
        <b-container fluid id="main_nav_title"
                     v-bind:style="{ 'padding-left': title_padding }">
          <b-row no-gutters>
            <b-col id="main_nav_title_text"
                   v-bind:style="{ display: title_display }">
              <router-link to="/">
                <b>xrpintel</b>
              </router-link>
            </b-col>
            <b-col id="main_nav_toggle" class="text-right" v-on:click="toggle_main_nav">
              <img src="@/assets/nav.svg" width=19 height=19 />
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>

    <template v-for="(section_details, section_id) in sections">
      <b-row no-gutters
             v-bind:key="section_id"
             v-bind:class="active(section_id) ? 'main_nav_current' : ''">
        <b-col cols=2 style="max-width: unset">
          <router-link v-bind:to="section_details.path">
              <a><b-img :src="active(section_id) ? nav_icon(section_details.icon) :
                                          disabled_nav_icon(section_details.icon)"
                        class="main_nav_icon"></b-img></a>
          </router-link>
        </b-col>

        <b-col>
          <router-link class="" v-bind:to="section_details.path" v-show="!collapsed">
            <a>{{section_details.title}}</a>
          </router-link>
        </b-col>
      </b-row>

      <template v-if="(active(section_id)  ||
                 child_active(section_id)) &&
             !!section_details['children']">
        <b-row no-gutters
               v-for="(child_details, child_id) in section_details.children"
               v-bind:key="child_id"
               v-bind:class="active(child_id) ? 'main_nav_current' : ''">
          <b-col cols="2" v-if="!collapsed" style="padding-left: 10px">∟</b-col>
          <b-col cols=2 style="max-width: unset">
            <router-link v-bind:to="child_details.path">
            <a><b-img :src="active(child_id) ? nav_icon(child_details.icon) :
                                      disabled_nav_icon(child_details.icon)"
                      :class="collapsed ? 'main_nav_icon' :
                                    'main_nav_child_icon'"></b-img></a>
            </router-link>
          </b-col>

          <b-col>
            <router-link class="" v-bind:to="child_details.path" v-show="!collapsed">
              <a>{{child_details.title}}</a>
            </router-link>
          </b-col>
        </b-row>
      </template>
    </template>
  </b-container>
</template>

<script>
import config from '../config'

export default {
  name: 'MainNav',

  props: {
    section: String
  },

  computed : {
    sections : function(){
      return config.NAV_SECTIONS;
    },

    width : function(){
      return this.$store.state.nav.width;
    },

    collapsed : function(){
      return this.$store.state.nav.collapsed;
    },

    title_padding : function(){
      return this.$store.state.nav.title_padding;
    },

    title_display : function(){
      return this.$store.state.nav.title_display;
    }
  },

  methods : {
    active : function(s){
      return s == this.section;
    },

    child_active : function(s){
      return        config.NAV_SECTIONS[s].children &&
        Object.keys(config.NAV_SECTIONS[s].children).includes(this.section);
    },

    toggle_main_nav : function(){
      this.$store.commit('toggle_nav', this.$mq);
    },

    nav_icon : function(i){
      return require('../assets/' + i + ".svg");
    },

    disabled_nav_icon : function(i){
      return require('../assets/' + i + "-disabled.svg");
    },

    outside_click : function(e){
      if((this.$mq == 'sm' || this.$mq == 'md') &&

          // XXX: exception for mobile title nav toggle
          e.target.id != "mobile_title_nav_toggle")
        this.$store.commit("collapse_nav", this.$mq);
    },

    // XXX: remove handle_resize when no longer needed
    //      (see nav css properties FIXME in store)
    handle_resize : function(){
      if(this.$mq != this.old_mq)
        this.$store.commit('update_nav', this.$mq);

      this.old_mq = this.$mq;
    }
  },

  mounted : function(){
    if(this.$mq == "sm" || this.$mq == 'md')
      this.$store.commit("collapse_nav", this.$mq);
  },

  // XXX: remove resize handling when no longer needed
  //      (see handle_resize above)

  created: function () {
    window.addEventListener('resize', this.handle_resize)
  },

  destroyed: function () {
    window.removeEventListener('resize', this.handle_resize)
  },
}
</script>

<style scoped>
#main_nav{
  border-right: 1px solid black;
  padding: 0;
  margin: 0;
  color: white;

  background-image: url("../assets/navbg.png");
}

#main_nav.sm,
#main_nav.md{
  overflow: hidden;
}

#main_nav a{
  color: white;
  text-decoration: none;

  display: inline-block;
  width: 100%;
}

#main_nav a:visited{
  color: white;
}

#main_nav > .row {
  padding-top: 5px;
  padding-bottom: 5px;
}

.main_nav_current{
  background-image: url("../assets/navbg-current.png");
}

#main_nav_title{
  padding: 0px;
  padding-right: 10px;
  margin-bottom: 25px;
}

#main_nav_title_text{
  padding-top: 15px;
  font-size: 1.4em;
}

#main_nav_toggle{
  cursor: pointer;
  margin-top: 20px;
  font-size: 1.2em;
}

.main_nav_icon{
  padding-left: 7px;
}

.main_nav_child_icon{
  padding-left: 4px;
}
</style>
